import type { ButtonProps as SurfaceButtonProps } from '@ankhorage/surface';

export type ZoraControlSize = NonNullable<SurfaceButtonProps['size']>;
